export interface Discount {
  name: string
  value: number
  hide?: boolean
}

export enum DiscountTypeCombination {
  bestDeal = 'BestDeal',
  stacking = 'Stacking',
}
